import { toast } from 'react-toastify';
import ModernToast from '../components/ModernToast';

export const showToast = (title, message, type = 'success') => {
  toast(<ModernToast title={title} message={message} type={type} />, {
    type: type, // This helps with progress bar color automatically if compatible
  });
};
